import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepagePl = () => {
    return <MakeHomepage languageCode="pl" />
}

export default MakeHomepagePl
